<template>
  <div class="btngroup-double">
    <div class="main">
      <slot name="main"></slot>
    </div>
    <div class="back">
      <slot name="back"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BtngroupDouble",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.btngroup-double {
  width: 100%;
  @include flex(flex, center, center, column, nowrap);
  @include mq-up(md) {
    @include flex(flex, flex-start, center, row-reverse, nowrap);
  }
  &.-margin-lg {
    margin: 40px 0 60px;
    @include mq-up(md) {
      margin: 60px 0 120px;
    }
  }
  &.-margin-sm {
    margin: 20px auto 20px;
    @include mq-up(md) {
      margin: 30px auto 30px;
    }
  }
  .main {
    max-width: 100%;
    margin: 0 auto 20px;
    @include mq-up(md) {
      margin: 0 auto;
      padding-right: 160px;
    }
  }
  .back {
    @include flex(flex, center, center, column, nowrap);
    width: 100%;
    @include mq-up(md) {
      width: 160px;
    }
  }
}
</style>
